import { createFileRoute } from "@tanstack/react-router";
import { CriarInsumoPage } from "@/paginas/criar-insumo";

export const Route = createFileRoute("/_authenticated/criar-insumo")({
  head: () => ({
    meta: [
      { title: "Criar insumo — Milky Moo Palmares" },
      { name: "description", content: "Cadastre um novo insumo no sistema." },
      { property: "og:title", content: "Criar insumo — Milky Moo Palmares" },
      { property: "og:description", content: "Cadastre um novo insumo no sistema." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: CriarInsumoPage,
});
